<template>
  <div v-once></div>
</template>
<script>
    import {pleaseWait} from 'please-wait';
    import 'please-wait/build/please-wait.css';

    export default {
        name: "Loader",
        props: ['isLoading'],
        watch: {
            isLoading: {
                handler(isLoading) {
                    if (isLoading) {
                        this.open()
                    } else {
                        this.close()
                    }
                },
                immediate: true,
            }
        },
        methods: {
            open() {
                // Attaching a `pleaseWaitInstance` property (no need to declare)...
                if (!this.pleaseWaitInstance) {
                    this.pleaseWaitInstance = pleaseWait({
                        logo: 'id_token' in localStorage ? (this.$store.getters.getReferrer.toUpperCase() === 'YSY' ? 'https://html-templates-ses-yoursynchronicity.s3-eu-west-1.amazonaws.com/public-assets/logo/YourSynchronicityLogoPng600x400.png' : "https://html-templates-ses-yoursynchronicity.s3-eu-west-1.amazonaws.com/public-assets/partners/".concat(this.$store.getters.getReferrer.toUpperCase(), "600x400.png")) : 'https://html-templates-ses-yoursynchronicity.s3-eu-west-1.amazonaws.com/public-assets/logo/YourSynchronicityLogoPng600x400.png',
                        backgroundColor: '#e7e9f4',
                        loadingHtml: '<?xml version="1.0" encoding="utf-8"?>\n' +
                            '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; display: block; shape-rendering: auto;" width="100px" height="100px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">\n' +
                            '<path fill="none" stroke="#07abcc" stroke-width="3" stroke-dasharray="42.76482137044271 42.76482137044271" d="M24.3 30C11.4 30 5 43.3 5 50s6.4 20 19.3 20c19.3 0 32.1-40 51.4-40 C88.6 30 95 43.3 95 50s-6.4 20-19.3 20C56.4 70 43.6 30 24.3 30z" stroke-linecap="round" style="transform:scale(1);transform-origin:50px 50px">\n' +
                            '  <animate attributeName="stroke-dashoffset" repeatCount="indefinite" dur="1.408450704225352s" keyTimes="0;1" values="0;256.58892822265625"></animate>\n' +
                            '</path>\n' +
                            '<!-- [ldio] generated by https://loading.io/ --></svg>' +
                            '<p class="loading-message">Please wait while we are connecting the bridge!</p>'
                    })
                }
            },
            close() {
                if (this.pleaseWaitInstance) {
                    this.pleaseWaitInstance.finish();
                    this.pleaseWaitInstance = null
                }
            }
        }
    }
</script>
<style scoped>
  .loading-message {
    color: white;
  }
</style>
